/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CmsFaqCategory,
  CmsFaqEntry,
  CmsFaqSubcategory,
  GetCmsFaqCategoryParams,
  GetCmsFaqEntryParams,
  GetCmsFaqSubcategoryParams,
  ListCmsFaqCategoriesParams,
  ListCmsFaqEntriesParams,
  ListCmsFaqSubcategoriesParams,
  PaginatedCmsFaqCategories,
  PaginatedCmsFaqEntries,
  PaginatedCmsFaqSubcategories,
  SchemaValidationErrorResponse,
  SearchCmsFaqEntriesParams,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List FAQ Categories
 */
export const listCmsFaqCategories = (
    params?: MaybeRefOrGetter<ListCmsFaqCategoriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCmsFaqCategories>(
      {url: `/cms/faq_categories`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCmsFaqCategoriesQueryKey = (params?: MaybeRefOrGetter<ListCmsFaqCategoriesParams>,) => {
    return [
    'cms','faq_categories', ...(params ? [params] : [])
    ] as const;
    }


export const getListCmsFaqCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCmsFaqCategories>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListCmsFaqCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCmsFaqCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCmsFaqCategories>>> = ({ signal }) => listCmsFaqCategories(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqCategories>>, TError, TData>
}

export type ListCmsFaqCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCmsFaqCategories>>>
export type ListCmsFaqCategoriesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List FAQ Categories
 */

export function useListCmsFaqCategories<TData = Awaited<ReturnType<typeof listCmsFaqCategories>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListCmsFaqCategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqCategories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCmsFaqCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary FAQ Category Details
 */
export const getCmsFaqCategory = (
    id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqCategoryParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<CmsFaqCategory>(
      {url: `/cms/faq_categories/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetCmsFaqCategoryQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqCategoryParams>,) => {
    return [
    'cms','faq_categories',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCmsFaqCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getCmsFaqCategory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqCategoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqCategory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCmsFaqCategoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsFaqCategory>>> = ({ signal }) => getCmsFaqCategory(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqCategory>>, TError, TData>
}

export type GetCmsFaqCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsFaqCategory>>>
export type GetCmsFaqCategoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary FAQ Category Details
 */

export function useGetCmsFaqCategory<TData = Awaited<ReturnType<typeof getCmsFaqCategory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqCategoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqCategory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCmsFaqCategoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List FAQ Entries
 */
export const listCmsFaqEntries = (
    params?: MaybeRefOrGetter<ListCmsFaqEntriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCmsFaqEntries>(
      {url: `/cms/faq_entries`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCmsFaqEntriesQueryKey = (params?: MaybeRefOrGetter<ListCmsFaqEntriesParams>,) => {
    return [
    'cms','faq_entries', ...(params ? [params] : [])
    ] as const;
    }


export const getListCmsFaqEntriesQueryOptions = <TData = Awaited<ReturnType<typeof listCmsFaqEntries>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListCmsFaqEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCmsFaqEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCmsFaqEntries>>> = ({ signal }) => listCmsFaqEntries(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqEntries>>, TError, TData>
}

export type ListCmsFaqEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCmsFaqEntries>>>
export type ListCmsFaqEntriesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List FAQ Entries
 */

export function useListCmsFaqEntries<TData = Awaited<ReturnType<typeof listCmsFaqEntries>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListCmsFaqEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCmsFaqEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Search FAQ Entries
 */
export const searchCmsFaqEntries = (
    params?: MaybeRefOrGetter<SearchCmsFaqEntriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCmsFaqEntries>(
      {url: `/cms/faq_entries/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchCmsFaqEntriesQueryKey = (params?: MaybeRefOrGetter<SearchCmsFaqEntriesParams>,) => {
    return [
    'cms','faq_entries','search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchCmsFaqEntriesQueryOptions = <TData = Awaited<ReturnType<typeof searchCmsFaqEntries>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<SearchCmsFaqEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCmsFaqEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchCmsFaqEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCmsFaqEntries>>> = ({ signal }) => searchCmsFaqEntries(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCmsFaqEntries>>, TError, TData>
}

export type SearchCmsFaqEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof searchCmsFaqEntries>>>
export type SearchCmsFaqEntriesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Search FAQ Entries
 */

export function useSearchCmsFaqEntries<TData = Awaited<ReturnType<typeof searchCmsFaqEntries>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<SearchCmsFaqEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCmsFaqEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCmsFaqEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary FAQ Entry Details
 */
export const getCmsFaqEntry = (
    id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqEntryParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<CmsFaqEntry>(
      {url: `/cms/faq_entries/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetCmsFaqEntryQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqEntryParams>,) => {
    return [
    'cms','faq_entries',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCmsFaqEntryQueryOptions = <TData = Awaited<ReturnType<typeof getCmsFaqEntry>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqEntryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqEntry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCmsFaqEntryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsFaqEntry>>> = ({ signal }) => getCmsFaqEntry(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqEntry>>, TError, TData>
}

export type GetCmsFaqEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsFaqEntry>>>
export type GetCmsFaqEntryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary FAQ Entry Details
 */

export function useGetCmsFaqEntry<TData = Awaited<ReturnType<typeof getCmsFaqEntry>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqEntryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCmsFaqEntryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List FAQ Subcategories
 */
export const listCmsFaqSubcategories = (
    params?: MaybeRefOrGetter<ListCmsFaqSubcategoriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCmsFaqSubcategories>(
      {url: `/cms/faq_subcategories`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCmsFaqSubcategoriesQueryKey = (params?: MaybeRefOrGetter<ListCmsFaqSubcategoriesParams>,) => {
    return [
    'cms','faq_subcategories', ...(params ? [params] : [])
    ] as const;
    }


export const getListCmsFaqSubcategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCmsFaqSubcategories>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListCmsFaqSubcategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqSubcategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCmsFaqSubcategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCmsFaqSubcategories>>> = ({ signal }) => listCmsFaqSubcategories(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqSubcategories>>, TError, TData>
}

export type ListCmsFaqSubcategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCmsFaqSubcategories>>>
export type ListCmsFaqSubcategoriesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List FAQ Subcategories
 */

export function useListCmsFaqSubcategories<TData = Awaited<ReturnType<typeof listCmsFaqSubcategories>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListCmsFaqSubcategoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCmsFaqSubcategories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCmsFaqSubcategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary FAQ Subcategory Details
 */
export const getCmsFaqSubcategory = (
    id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqSubcategoryParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<CmsFaqSubcategory>(
      {url: `/cms/faq_subcategories/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetCmsFaqSubcategoryQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqSubcategoryParams>,) => {
    return [
    'cms','faq_subcategories',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCmsFaqSubcategoryQueryOptions = <TData = Awaited<ReturnType<typeof getCmsFaqSubcategory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqSubcategoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqSubcategory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCmsFaqSubcategoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCmsFaqSubcategory>>> = ({ signal }) => getCmsFaqSubcategory(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqSubcategory>>, TError, TData>
}

export type GetCmsFaqSubcategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCmsFaqSubcategory>>>
export type GetCmsFaqSubcategoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary FAQ Subcategory Details
 */

export function useGetCmsFaqSubcategory<TData = Awaited<ReturnType<typeof getCmsFaqSubcategory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetCmsFaqSubcategoryParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCmsFaqSubcategory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCmsFaqSubcategoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






